const config = {
  BACKEND_API_URL: process.env.REACT_APP_BACKEND_API_URL || "http://localhost:8080",
};

export default config;
